export const BOOK_TYPE = {
    BOOK: "book",
    STUDY: "study",
    RESOURCE: "resource"
}

export const BOOK_TYPE_MAP = new Map();

BOOK_TYPE_MAP.set(BOOK_TYPE.BOOK, BOOK_TYPE.BOOK)
BOOK_TYPE_MAP.set(BOOK_TYPE.STUDY, BOOK_TYPE.STUDY)
BOOK_TYPE_MAP.set(BOOK_TYPE.RESOURCE, BOOK_TYPE.RESOURCE)
BOOK_TYPE_MAP.set("1", BOOK_TYPE.BOOK)
BOOK_TYPE_MAP.set("2", BOOK_TYPE.STUDY)
BOOK_TYPE_MAP.set("3", BOOK_TYPE.RESOURCE)